import { createListenerMiddleware } from '@reduxjs/toolkit';

import { clearDiscountDataFromSessionStorage } from 'wanderu-discount';
import { declineInsurance, discountCleared } from 'wanderu-orders';

import { selectors as bookingSelectors } from './appstate';

// eslint-disable-next-line no-console -- standalone listener; default fallback when host app provides no onError
function defaultOnError(context, error, meta) {
    console.error(context, error, meta);
}

export function createBookingListenerMiddleware({
    onError = defaultOnError,
    selectInsuranceVisible = bookingSelectors.selectInsuranceVisible,
} = {}) {
    const middleware = createListenerMiddleware();

    const insuranceBecameHidden = (action, currentState, previousState) => {
        // Guard: the listener is registered globally but the booking reducer is lazy-injected.
        // Selectors throw if the slice isn't mounted yet (e.g. on the search page).
        try {
            const wasVisible = selectInsuranceVisible(previousState) === true;
            const nowHidden = selectInsuranceVisible(currentState) === false;
            return wasVisible && nowHidden;
        } catch {
            return false;
        }
    };

    middleware.startListening({
        effect: async (_action, listenerApi) => {
            const result = await listenerApi.dispatch(declineInsurance());
            if (declineInsurance.rejected.match(result)) {
                onError('[wanderu-app-booking] Failed to decline insurance on reset:', result.error, {
                    payload: result.payload,
                });
            }
        },
        predicate: insuranceBecameHidden,
    });

    middleware.startListening({
        actionCreator: discountCleared,
        effect: () => clearDiscountDataFromSessionStorage(),
    });

    return middleware;
}
